import { createSlice } from '@reduxjs/toolkit'
import { MAX_NOTIFICATION_VISIBLE } from '@/common/constants/count'

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    notificationIsVisible: false,
  },
  reducers: {
    addNotification: (state, { payload }) => {
      const updateData = {
        ...payload,
        id: Date.now(),
      }

      if (state.notifications.length >= MAX_NOTIFICATION_VISIBLE) {
        state.notifications.pop()
      }

      state.notifications.push(updateData)
    },
    removeNotification: (state, { payload }) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== payload
      )
    },
    setNotificationIsVisible: (state) => {
      state.notificationIsVisible = !state.notificationIsVisible
    },
  },
})

export const notificationsActions = notificationsSlice.actions
export const { addNotification } = notificationsSlice.actions

export default notificationsSlice.reducer
